export default {
  fillForm: 'Fill the form'
}
